import { ReorderSuggestionStatus } from '@parallel-fluidics/shared/constants';
import { reorderSuggestionFromFirestore } from '@parallel-fluidics/shared/models/inventory';
import {
  collection,
  getFirestore,
  orderBy,
  where,
} from 'firebase/firestore';
import useCustomInfiniteQuery from 'hooks/use-customInfiniteQuery';
import { useMemo } from 'react';

export default function useOpenReorderSuggestionsQuery({ pageSize = 10 } = {}) {
  const queryParams = useMemo(() => [
    collection(getFirestore(), 'reorderSuggestions'),
    where('status', '==', ReorderSuggestionStatus.OPEN),
    orderBy('updatedAt', 'desc'),
  ], []);

  return useCustomInfiniteQuery({
    queryKey: 'openReorderSuggestions',
    queryParams,
    pageSize,
    staleTime: 5 * 60 * 1000,
    transformData: reorderSuggestionFromFirestore,
  });
}
